export enum ViewType {
  Edit,
  View
}
